<div class="wrapper">
  <div class="row" style="text-align: end">
    <i
      class="fas fa-times clickable"
      (click)="activeModal.dismiss('Cross click')"
    ></i>
  </div>
  <header>
    <ng-container i18n="@@changeblock.header">Change Block</ng-container>
  </header>
  <div class="d-flex flex-column">
    <div class="d-flex flex-column justify-content-center selectors">
      <div class="dropdown p-2">
        <button
          class="btn dropdown-toggle is-flex fix-content"
          type="button"
          id="dropdownMenu1"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ this.selectedCity || "City" }}
        </button>
        <div
          class="dropdown-menu fit-content dropdown-menu-1"
          aria-labelledby="dropdownMenu1"
        >
          <button
            class="dropdown-item"
            *ngFor="let city of cityList"
            (click)="selectCity(city)"
            type="button"
          >
            {{ city }}
          </button>
        </div>
      </div>
      <div class="dropdown p-2">
        <button
          class="btn dropdown-toggle is-flex fix-content"
          type="button"
          id="dropdownMenu2"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ this.selectedFiberhood?.fiberHood || "Fiberhood" }}
        </button>
        <div
          class="dropdown-menu fit-content dropdown-menu-2"
          aria-labelledby="dropdownMenu2"
        >
          <button
            class="dropdown-item"
            *ngFor="let fiberhood of fiberhoodList"
            (click)="selectFiberhood(fiberhood)"
            type="button"
          >
            {{ fiberhood.fiberHood }}
          </button>
        </div>
      </div>
      <div class="dropdown p-2">
        <button
          class="btn dropdown-toggle is-flex fix-content"
          type="button"
          id="dropdownMenu3"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ this.selectedBlock?.block.toString() || "Block" }}
        </button>
        <div
          class="dropdown-menu fit-content dropdown-menu-3"
          aria-labelledby="dropdownMenu3"
        >
          <button
            class="dropdown-item"
            *ngFor="let block of blockList"
            (click)="selectBlock(block)"
            type="button"
          >
            {{ block.block.toString() }}
          </button>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center confirm">
      <button
        type="button"
        [ngClass]="{ 'button-inactive': !selectedBlock }"
        class="trigger text-uppercase mr-2"
        (click)="updateBlock()"
      >
        Change Buildings to Block
      </button>
    </div>
  </div>
</div>
